import { FC, useCallback, useMemo } from 'react';

import {
  ButtonGroup,
  Icon,
} from '@beeline/design-system-react/extracted-styles';
import {
  ButtonGroupOption,
  ButtonGroupOptionsArray,
} from '@beeline/design-system-react/types/components/ButtonGroup/ButtonGroup.types';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import { TooltipWrapper } from 'src/components/TooltipWrapper/TooltipWrapper';

import { useFloorMap } from '../FloorMapProvider';
import { MAX_ZOOM, MIN_ZOOM } from '../consts';
import { calculateNextZoom } from '../utils';

import classes from './ZoomButtons.module.scss';

enum ZoomOption {
  Increase,
  Decrease,
}

export const ZoomButtons: FC = () => {
  const { zoomRef, zoomValue, containerDimensionsRef, zoom } = useFloorMap();

  const changeMode = useCallback(
    (option: ButtonGroupOption) => {
      const nextZoom = calculateNextZoom(
        (option.id as unknown as ZoomOption) === ZoomOption.Increase,
        zoomRef.current,
      );
      zoom(nextZoom, {
        x: containerDimensionsRef.current.width / 2,
        y: containerDimensionsRef.current.height / 2,
      });
    },
    [containerDimensionsRef, zoom, zoomRef],
  );

  const options = useMemo(
    (): ButtonGroupOptionsArray => [
      {
        // @ts-expect-error ButtonGroupOption type is incorrect
        id: ZoomOption.Increase,
        startIcon: <Icon iconName={Icons.Add} />,
        wrapper: ({ children }) => (
          <TooltipWrapper title={'Приблизить'}>{children}</TooltipWrapper>
        ),
        disabled: zoomValue === MAX_ZOOM,
      },
      {
        // @ts-expect-error ButtonGroupOption type is incorrect
        id: ZoomOption.Decrease,
        startIcon: <Icon iconName={Icons.Remove} />,
        wrapper: ({ children }) => (
          <TooltipWrapper title={'Отдалить'}>{children}</TooltipWrapper>
        ),
        disabled: zoomValue === MIN_ZOOM,
      },
    ],
    [zoomValue],
  );

  return (
    <div className={classes.container}>
      <ButtonGroup onChange={changeMode} options={options} />
    </div>
  );
};
